var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"},attrs:{"id":"app"}},[_c('Menu',{attrs:{"config":_vm.env}}),_c('transition',{attrs:{"name":"fade","appear":""}},[_c('router-view',{key:_vm.$route.fullPath,attrs:{"config":_vm.env,"meta_data":_vm.wp_meta_page}})],1),_c('CookieBanner'),_c('Footer',{attrs:{"config":_vm.env}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }